import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFolderOpen,
  faClipboardCheck,
  faChartSimple,
  faScaleBalanced,
  faLink,
  faFileSignature
} from '@fortawesome/free-solid-svg-icons';
import styles from './WorkflowSection.module.css';

const workflowSteps = [
  {
    icon: faFolderOpen,
    label: 'Ingest',
    title: 'Collect the record',
    text: 'Bring pleadings, contracts, damages materials, correspondence, timelines, and diligence notes into one matter workspace.'
  },
  {
    icon: faClipboardCheck,
    label: 'Structure',
    title: 'Build the screening dossier',
    text: 'Separate known facts, missing inputs, threshold blockers, and first diligence questions before assumptions harden.'
  },
  {
    icon: faChartSimple,
    label: 'Screen',
    title: 'Review risk posture',
    text: 'Evaluate the matter through a consistent internal framework while keeping judgment and next-step decisions with the team.'
  },
  {
    icon: faScaleBalanced,
    label: 'Pressure-test',
    title: 'Challenge key assumptions',
    text: 'Expose damages, duration, enforceability, and recovery assumptions that need support before committee review.'
  },
  {
    icon: faLink,
    label: 'Evidence-link',
    title: 'Tie conclusions to sources',
    text: 'Keep findings connected to document references, reviewer notes, and unresolved diligence items.'
  },
  {
    icon: faFileSignature,
    label: 'Package',
    title: 'Prepare committee work product',
    text: 'Create a repeatable underwriting record the team can compare, challenge, defend, and remember.'
  }
];

const WorkflowSection = () => {
  return (
    <section id="workflow-section" className={styles.section} aria-labelledby="workflow-heading">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.badge}>Analyst Workflow</span>
          <h2 id="workflow-heading" className={styles.title}>
            VerdeKai turns underwriting into a sequence.
          </h2>
          <p className={styles.subtitle}>
            The product is not an AI score. It is a repeatable method for moving from
            messy materials to an evidence-linked record that can survive partner and IC review.
          </p>
        </div>

        <div className={styles.workflowGrid}>
          {workflowSteps.map((step, index) => (
            <article key={step.label} className={styles.workflowCard}>
              <div className={styles.cardHeader}>
                <span className={styles.stepNumber}>{String(index + 1).padStart(2, '0')}</span>
                <div className={styles.iconBox}>
                  <FontAwesomeIcon icon={step.icon} className={styles.icon} />
                </div>
              </div>
              <span className={styles.stepLabel}>{step.label}</span>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepText}>{step.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
